module.exports = __webpack_public_path__ + "static/media/metrics.1b2e8460.jpg";